module.exports = __webpack_public_path__ + "img/chatbot.8d526a4c.png";